import { createRouter, createWebHistory } from 'vue-router';
import LoopSong from '@/utils/sounds';

// Lazy load route components to avoid circular dependencies
const Home = () => import('@/views/Home.vue');
const Settings = () => import('@/views/Settings.vue');
const Player = () => import('@/views/Player.vue');
const AgeSetting = () => import('@/components/AgeSetting.vue');
const Folder = () => import('@/views/Folder.vue');
const Game = () => import('@/views/Game.vue');
const Puzzle = () => import('@/views/Puzzle.vue');
const Search = () => import('@/views/Search.vue');

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/folder/:identifier',
      name: 'folder',
      component: Folder,
      props: true,
    },
    {
      path: '/game/:identifier',
      name: 'game',
      component: Game,
    },
    {
      path: '/player/:videoId',
      name: 'player',
      component: Player,
      props: true,
    },
    {
      path: '/:partner?/:action?',
      name: 'home',
      component: Home,
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
    },
    {
      path: '/age',
      name: 'age',
      component: AgeSetting,
    },
    {
      path: '/gaming/:gameType/:identifier/:position',
      name: 'gaming',
      component: Puzzle,
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
    },
  ],
});

router.beforeEach((to, from) => {
  localStorage.setItem('lastRouteName', from && from.name ? String(from.name) : '');
});

router.afterEach(() => {
  // Try to play on route change
  LoopSong.play();
});

export default router;
